export default {
  route: {
    template: 'Dejar un comentario - {n}',
    fallback: 'Dejar un comentario',
    //dynamic use
    aboutVisit: 'Acerca de la visita',
    checkout: 'Salida',
    digitalReceipt: 'Recibo digital',
    findVenue: 'Encontrar sede',
    getStarted: 'Empecemos',
    guestReceiptPinEntry: 'Ingreso del PIN del recibo de invitado',
    guestTableNumberEntry: 'Ingreso del número de mesa',
    index: '',
    listNearbyLocations: 'Lista de ubicaciones cercanas',
    locationCheckIn: 'Registro de ubicación',
    manageTeam: 'Gestionar equipo',
    questions: 'Preguntas',
    register: 'Registrar dispositivo',
    recommend: 'Recomendar',
    share: 'Compartir',
    staff: 'Miembro del equipo',
    survey: 'Encuesta para invitado',
    thankYou: 'Not Implemented.',
    // TODO: Translate (PWA)
    tabletCheckIn: 'Registro de tableta',
    teamMemberReceiptPinEntry: 'Ingreso del PIN del recibo de miembro del equipo',
    teamMemberTableNumberEntry: 'Ingreso del número de mesa de miembro del equipo',
    upload: 'Cargar',
    error404: '404'
  }
};